import { FC } from 'react'
import styles from './CheckpointGrade.module.css'
import cn from 'utils/cn'
import { getGradeVariant } from 'utils/getGradeVariant'

interface GradeProps {
  grade: number | null | undefined
}

const Grade: FC<GradeProps> = ({ grade }) => {
  const variant = grade != null ? getGradeVariant(grade) : null

  return (
    <div className={cn(styles.grade, variant && styles[variant])}>
      <p className={cn('text--caption-s text--bold', variant ? styles.caption : 'text--secondary')}>Оценка</p>
      <p className={cn('text--heading-h3 text--bold', variant && styles.value)}>{grade ?? '--'}</p>
    </div>
  )
}

export default Grade
